/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function FormText({
  value,
  onChange,
  disabled,
  singleLine,
  maxLength,
  squat,
  valid,
  ...props
}) {
  const handleChange = (e) => {
    if (singleLine) {
      e.target.value = e.target.value.replace(/[\r\n]+/g, '');
    }
    // if (maxLength > -1) {
    //   e.target.value = e.target.value.slice(0, maxLength);
    // }
    onChange(e);
  };
  return (
    <textarea
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.mainContainerDisabled]: disabled,
          [Styles.mainContainerSingleLine]: singleLine,
          [Styles.mainContainerSingleLineSquat]: singleLine && squat,
          [Styles.mainContainerSingleLineDisabled]: singleLine && disabled,
          [Styles.mainContainerSquat]: squat,
          [Styles.mainContainerInvalid]: !valid,
        },
      )}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      spellCheck={false}
      {...props}
    />
  );
}

FormText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  singleLine: PropTypes.bool,
  maxLength: PropTypes.number,
  squat: PropTypes.bool,
  valid: PropTypes.bool,
};

FormText.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  singleLine: false,
  maxLength: -1,
  squat: false,
  valid: true,
};
